/**
 * Centered auth / password-reset layout — bone canvas, narrow column.
 * @see frontend/src/design/DESIGN.md (auth centered-form pattern)
 */
import React from 'react';
import AuraLogo from '../AuraLogo';

const AuthFormLayout = ({ headline, subhead, children, footer }) => (
  <div className="min-h-screen bg-bone flex items-center justify-center px-4 py-12">
    <div className="w-full max-w-md auth-form-column">
      <div className="text-center mb-8">
        <AuraLogo showText size="large" className="justify-center mx-auto mb-8" />
        {headline && (
          <h1 className="font-display text-h1 text-primary">{headline}</h1>
        )}
        {subhead && (
          <p className="text-body text-secondary mt-3 max-w-sm mx-auto">{subhead}</p>
        )}
      </div>
      <div className="auth-form-panel">{children}</div>
      {footer ? <div className="mt-6 text-center">{footer}</div> : null}
    </div>
  </div>
);

export default AuthFormLayout;
